import { render, staticRenderFns } from "./wallet-logs.vue?vue&type=template&id=f4c77c92&"
import script from "./wallet-logs.vue?vue&type=script&lang=js&"
export * from "./wallet-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports